import React from 'react';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import { useSiteContext } from '../components/SiteContext';
import withApollo from '../lib/apollo';
import redirectRouteToDomain from '../lib/redirectRouteToDomain';
import loading from '../lib/loading';

const CompanyLayout = dynamic(() => import('../components/Company/Layout'), {
  ssr: true,
  loading,
});

const Profile = dynamic(() => import('../components/Company/Profile'), {
  ssr: true,
  loading,
});

const CompanyProfilePage = () => {
  const { query: { slug } } = useRouter();
  const { locale } = useSiteContext();

  return (
    <Profile
      slug={slug}
      locale={locale}
    />
  );
};

CompanyProfilePage.getLayout = (page) => <CompanyLayout>{page}</CompanyLayout>;

CompanyProfilePage.getInitialProps = redirectRouteToDomain(
  'company-profile',
);

const CompanyProfilePageWithApollo = withApollo(CompanyProfilePage);

export default CompanyProfilePageWithApollo;
